"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var types_1 = require("../state/types");
var reducer_1 = __importDefault(require("../state/reducer"));
var utils_1 = require("../lib/utils");
var useMedia = function (initialState, fadeSettings) {
    var _a = react_1.useReducer(reducer_1.default, initialState), state = _a[0], dispatch = _a[1];
    var pause = react_1.useCallback(function (el) {
        el.pause();
        state.playerTimeout && clearInterval(state.playerTimeout);
        dispatch({ type: types_1.ActionType.PAUSE });
    }, [state.playerTimeout]);
    var setCurrentTime = react_1.useCallback(function (el, value) {
        var currentFade = fadeSettings ? utils_1.getFade(fadeSettings, el.duration, el.currentTime) : 1;
        var currentTime = value === undefined ?
            el.currentTime :
            (value / 100) * (el.duration || 0);
        if (value !== undefined) {
            el.currentTime = currentTime;
        }
        var progressTime = {
            currentTime: currentTime,
            duration: el.duration,
        };
        dispatch({
            type: types_1.ActionType.UPDATE_TIME,
            payload: {
                time: progressTime,
                fade: currentFade,
            }
        });
    }, [fadeSettings]);
    var load = react_1.useCallback(function (el, url) {
        dispatch({
            type: types_1.ActionType.UPDATE_URL,
            payload: url,
        });
        el.src = url;
        el.load();
    }, []);
    var play = react_1.useCallback(function (el) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: types_1.ActionType.PLAY,
                        payload: setInterval(function () {
                            setCurrentTime(el);
                        }, 50),
                    });
                    return [4 /*yield*/, el.play()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [setCurrentTime]);
    var stop = react_1.useCallback(function (el) {
        pause(el);
        setCurrentTime(el, 0);
    }, [pause, setCurrentTime]);
    var setProgress = react_1.useCallback(function (el, value) { return __awaiter(void 0, void 0, void 0, function () {
        var audioUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!el.src) return [3 /*break*/, 2];
                    return [4 /*yield*/, utils_1.getUrl(state.src)];
                case 1:
                    audioUrl = _a.sent();
                    load(el, audioUrl);
                    el.onloadedmetadata = function () { return setCurrentTime(el, value); };
                    return [2 /*return*/];
                case 2:
                    setCurrentTime(el, value);
                    return [2 /*return*/];
            }
        });
    }); }, [setCurrentTime, load, state.src]);
    var setSize = react_1.useCallback(function (el) {
        var width = state.width || el.videoWidth;
        var height = state.width ? (el.videoHeight * width / el.videoWidth) : el.videoHeight;
        dispatch({
            type: types_1.ActionType.UPDATE_SIZE,
            payload: {
                width: width,
                height: height
            },
        });
    }, [state.width, dispatch]);
    var updateSrc = react_1.useCallback(function (src) {
        dispatch({
            type: types_1.ActionType.UPDATE_KEY,
            payload: {
                key: Math.random(),
                src: src,
            },
        });
    }, []);
    react_1.useEffect(function () {
        dispatch({
            type: types_1.ActionType.RELOAD,
            payload: initialState,
        });
    }, [initialState.src]);
    react_1.useEffect(function () {
        updateSrc(state.src);
    }, [state.src, updateSrc]);
    react_1.useEffect(function () {
        return function () {
            state.playerTimeout && clearInterval(state.playerTimeout);
        };
    }, [state.playerTimeout]);
    return { state: state, pause: pause, stop: stop, setCurrentTime: setCurrentTime, load: load, play: play, setProgress: setProgress, setSize: setSize };
};
exports.default = useMedia;
//# sourceMappingURL=useMedia.js.map